<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "App",
  data() {
    return{}
  },
  mounted() {
    localStorage.setItem('WxVodeUrl',location.href.split("#")[0])
  }
};
</script>

<style lang="scss">
#app {
  font-family: ArialMT, "PingFang SC", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #4a4a4a;
}
</style>
